module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "component-body with-padding"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "coupon-component",
      class: {
        'with-img': item.imgUrl
      }
    }, [(item.imgUrl) ? [_c('img', {
      staticClass: "coupon-img",
      attrs: {
        "src": item.imgUrl
      }
    })] : [_c('div', {
      staticClass: "coupon-amount"
    }, [_c('div', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), (item.type === 'cash') ? _c('div', {
      staticClass: "amount-cur"
    }, [_vm._v("RMB")]) : _vm._e(), _vm._v(" "), (item.type === 'discount') ? _c('div', {
      staticClass: "amount-cur"
    }, [_vm._v("折")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "coupon-brand"
    }, [_c('img', {
      staticClass: "brand-img",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "coupon-caption"
    }, [_c('div', {
      staticClass: "coupon-content"
    }, [_c('div', {
      staticClass: "brand-name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "coupon-desc"
    }, [_vm._v(_vm._s(item.desc))])])])], _vm._v(" "), _c('el-button', {
      staticClass: "coupon-getted-btn",
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("领取")])], 2)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6446bfa9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6446bfa9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/coupon.vue
// module id = 2781
// module chunks = 0